import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import NavBar from '../components/NavBar';
import { Button } from '../components/ui/button';
import { authAPI, formatApiError } from '../lib/api';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, ok: false, message: 'E-posta onaylanıyor...' });

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setState({ loading: false, ok: false, message: 'Onay tokenı bulunamadı.' });
      return;
    }
    authAPI.verifyEmail(token)
      .then((r) => setState({ loading: false, ok: true, message: r.data?.message || 'E-posta onaylandı.' }))
      .catch((e) => setState({ loading: false, ok: false, message: formatApiError(e) }));
  }, [params]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <NavBar />
      <div className="max-w-lg mx-auto px-4 py-20">
        <div className="aurora-card rounded-3xl p-10 text-center">
          {state.loading ? (
            <Loader2 className="w-14 h-14 mx-auto mb-5 animate-spin text-fuchsia-400" />
          ) : state.ok ? (
            <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
              <CheckCircle2 className="w-8 h-8 text-emerald-400" />
            </div>
          ) : (
            <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-rose-500/15 border border-rose-500/30 flex items-center justify-center">
              <XCircle className="w-8 h-8 text-rose-400" />
            </div>
          )}
          <h1 className="text-2xl font-bold mb-2">E-posta Onayi</h1>
          <p className="text-muted-foreground mb-6">{state.message}</p>
          {!state.ok && !state.loading && (
            <p className="text-sm text-muted-foreground mb-4">Token daha once kullanilmis olabilir. Zaten onayliysaniz giris yapin.</p>
          )}
          <Link to={state.ok ? "/dashboard" : "/login"}>
            <Button className="bg-gradient-to-r from-fuchsia-500 to-indigo-500 hover:from-fuchsia-600 hover:to-indigo-600">
              {state.ok ? 'Panelime Git' : 'Giris Yap'}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
